import {Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class WidgetsHelper {
    filterLoadData(excluded, projects, groups) {
        const summaryProjectIds = projects.filter(item => excluded.indexOf(item.name) === -1).map(item => item.id);
        const summaryGroupIds = groups.filter(item => excluded.indexOf(item.name) === -1).map(item => item.id);
        return { summaryProjectIds, summaryGroupIds };
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/widgets-helper.service.ts